import { render, staticRenderFns } from "./music.vue?vue&type=template&id=c3cf79bc"
var script = {}
import style0 from "./music.vue?vue&type=style&index=0&id=c3cf79bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports